import { useCallback, useContext, useEffect, useState } from "react";
import "./App.scss";
import "./App.css";
import { ThemeContext } from "./context/ThemeContext";
import { DARK_THEME, LIGHT_THEME } from "./constants/themeConstants";
import { HashRouter as Router, Routes, Route } from "react-router-dom";
import BaseLayout from "./layout/BaseLayout.jsx";
import * as XLSX from "xlsx";
import {
  AdminDashboard,
  ApiIntegrationPage,
  ChangePassword,
  Dashboard,
  DirectPayout,
  DownloadReport,
  Lookup,
  MerchantDashboard,
  MerchantManagement,
  PageNotFound,
  PayOutForm,
  PayOutReport,
  RollingReserve,
  RollingReserveSettlements,
  RefundPage,
  RevenuePage,
  Reconciliation,
  ReconciliationTable,
  UserManagement,
  SettlementPage,
  SettingPage,
  TransactionLookup,
  AutoPayoutReport,
  ActivityPage,
  AccountNavbar
} from "./screens";
import LoginScreen from "./screens/login/LoginScreen.jsx";
import SignUpScreen from "./screens/sign/SignUpPage.jsx";
import Payment from "./screens/payment/PaymentPage.jsx";
import AccountPage from "./screens/account/accountPage.jsx";
import AddProvider from "./screens/Provider/index.jsx";
import GetProvider from "./screens/Provider/components/GetProvider.jsx";
import { Navigate } from "react-router-dom";
import "react-date-range/dist/styles.css";
import "react-date-range/dist/theme/default.css";
// import { generateNewToken } from "./config/LiveApi.js";
import ReconDashboard from "./screens/Reconciliation/components/ReconDashboard.jsx";
import { useSelector, useDispatch } from "react-redux";
import userSlice from "./redux/slices/userSlice.js";
import MonthlyAnalytics from "./screens/MonthlyAnalytics/index.jsx";
import DashboardAnalyst from "./screens/OrganizationAnalysis/index.jsx";
import OrgTable from "./screens/OverviewTable/Index.jsx";
import AddOrg from "./screens/AddOrganization/Index.jsx";
import AddSettlements from "./screens/AccountsSettlement/AddSettlements.jsx";
import GetSettlements from "./screens/AccountsSettlement/GetSettlements.jsx";
import WalletTransactionTable from "./screens/WalletBalance/Components/WalletTable.jsx";
import WalletBalance from "./screens/WalletBalance/index.jsx";
import WalletUpload from "./screens/WalletUpload/index.jsx";
// import Passbook from "./screens/passbook/index.jsx";
import ChangeStatus from "./screens/ChangeStatus/index.jsx";
import ControlPanel from "./screens/ControlPanel/index.jsx";
import RegisterAutoSwitch from "./screens/RegisterAutoSwitch/index.jsx";
import ViewAutoSwitch from "./screens/ViewAutoSwitch/index.jsx";
import WalletRequest from "./screens/WalletRequest/index.jsx";
import WalletHistory from "./screens/WalletHistory/index.jsx";
import WalletPending from "./screens/WalletPending/index.jsx";
import MerchantWebhooks from "./screens/MerchantWebhooks/index.jsx";
import MerchantIPs from "./screens/MerchantIps/index.jsx";
import MerchantApiKey from "./screens/MerchantApiKeys/index.jsx";
import SettlementReport from "./screens/SettlementReport/index.jsx";
import TotalProviderSettlement from "./screens/TotalProviderSettlement/index.jsx";
import MerchantSettlement from "./screens/MerchnatSettlement/index.jsx";
import DownloadGenerateReports from "./screens/DownloadGenerateReports/index.jsx";
import ActiveUsers from "./components/activeUsers/ActiveUsers.jsx";
import ApproveSettlement from "./screens/MerchnatSettlement/PenddingSettlement/index.jsx";
import ApproveRollingSettlement from "./screens/MerchnatSettlement/PenddingRollingSettlement/index.jsx";
import ActivityStatusPage from "./screens/activity/change-status/ActivityStatusPage.jsx";
import BlockedUserPage from "./screens/activity/blocked-user/BlockedUserScreen.jsx";
import RawWebhookPage from "./screens/activity/raw-webhook/RawWebhookScreen.jsx";
import ChangePasswordPage from "./screens/activity/change-password/ChangePasswordScreen.jsx";
import MerchantOverview from "./screens/MerchantOverview/index.jsx";
import ChargebackStats from "./screens/ReconciliationTable/components/ChargebackStats.jsx";
import CheckProvider from "./screens/Provider/components/CheckProvider.jsx";
import BlockKeywordPage from "./screens/activity/block-keyword/BlockKeywordScreen.jsx";
import VpaPool from "./screens/VpaPool/index.jsx";
import VpaUsage from "./screens/VpaUsage/index.jsx";
import GenerateProducts from "./screens/GenerateProducts/index.jsx";
import NotFoundWebhookPage from "./screens/activity/notFound-webhook/NotFoundWebhook.jsx";
// import BlockKeywordPage from "./screens/activity/Block-Keyword/BlockKeywordScreen.jsx";
// import BlockKeywordPage from "./screens/activity/Block-Keyword/BlockKeywordScreen.jsx";
import ErrorWebhook from "./screens/Notification/components/ErrorWebhook.jsx";
import SuspiciousTnx from "./screens/Notification/components/SuspiciousTnx.jsx";
import FraudChargeback from "./screens/Notification/components/FraudChargeback.jsx";
import VpaRefund from "./screens/VpaRefund/index.jsx";
import PreChargebackEvaluation from "./screens/Reconciliation/components/Pre-ChargebackEvaluation/PreChargebackEvaluation.jsx";
import ProviderUserSet from "./screens/ProviderMerchant/index.jsx";
import ProviderWallet from "./screens/ProviderWalletLoad/index.jsx";
import ProviderWalletAvilableBalance from "./screens/ProviderWalletLoad/components/ProviderWalletAvilableBalance.jsx";
import ComplaintsDashboard from "./screens/Complaints/components/ComplaintsDashboard.jsx";
import Complaints from "./screens/Complaints/index.jsx";
import ComplaintTable from "./screens/ComplaintTable/index.jsx";
import ApproveComplaints from "./screens/Complaints/components/ApproveComplaint.jsx";
import ClearPending from "./screens/PayoutPenddinggClear/ClearPending.jsx";
import UuidPayout from "./screens/PayoutPenddinggClear/UuidPayout.jsx";
import TodaysChargeback from "./screens/Reconciliation/components/TodaysChargeback.jsx";
import ReconMatch from "./screens/ReconMatch/index.jsx";
import TransactionSummary from "./screens/ReconMatch/components/TransactionSummary.jsx";
import MuffinClear from "./screens/ReconMatch/components/MuffinClear.jsx";
import WebhookTracker from "./screens/WebhookTracker/index.jsx";
import PayNinjaClear from "./screens/ReconMatch/components/PayNinjaClear.jsx";
import PayoutPendingSummary from "./screens/PayoutPendingSummary/index.jsx";
import PayoutPendingGetData from "./screens/PayoutPendingSummary/GetPenddingData.jsx";
import PayoutPendingFailed from "./screens/PayoutPendingSummary/FailedPendingPayout.jsx";
import RetryCallback from "./screens/PayoutPendingSummary/RetryCallback.jsx";
import PendingPayouts from "./screens/ReconMatch/components/PendingPayouts.jsx";
import GetReseller from "./screens/Reseller/components/GetReseller.jsx";
import ResellerManagement from "./screens/Reseller/components/ResellerManagement.jsx";
import ResellerWallet from "./screens/Reseller/components/ResellerWallet.jsx";
import GetAllResellerWallet from "./screens/Reseller/components/GetAllResellerWallet.jsx";
import ResellerDashboard from "./screens/Reseller/components/ResellerDashboard.jsx";
import AllResellerDashboard from "./screens/Reseller/components/AllResellerDashboard.jsx";
import NSpayReport from "./screens/NsPayReport/Report.jsx"
import UserAnalytics from "./screens/UserLedger/index.jsx";
import BlockFraudUsers from "./screens/BlockUser/BlockFraudUsers.jsx";
import PaymentExceptionDashboard from "./screens/RefundsData/components/PaymentExceptionDashboard.jsx";
import MuffinAmount from "./screens/ReconMatch/components/MuffinAmount.jsx";
import PayinUpload from "./screens/PayinUpload/index.jsx";
import NotificationsPage from "./screens/Notification/index.jsx";
import ShowNotifcation from "./screens/Notification/components/ShowNotifcation.jsx";
import WhitelistRequest from "./screens/Notification/components/WhitelistRequest.jsx";
import ProviderTrackingScreen from "./screens/providerTracking/ProviderTrackingScreen.jsx";
const { actions } = userSlice;

function App() {
  const { theme } = useContext(ThemeContext);
  const [typeError, setTypeError] = useState(null);
  const [excelFile, setExcelFile] = useState(null);
  const [excelData, setExcelData] = useState(null);
  const dispatch = useDispatch();
  const token = useSelector((state) => state.userReducer.token);
  const role = useSelector((state) => state.userReducer.role);
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => setOpen(true), []);

  const handleClose = useCallback(() => setOpen(false), []);

  useEffect(() => {
    if (theme === DARK_THEME) {
      document.body.classList.add("dark-mode");
    } else {
      document.body.classList.remove("dark-mode");
    }
  }, [theme]);

  // const refreshToken = async () => {
  //   const currentToken = token;
  //   if (!currentToken) return;

  //   try {
  //     const response = await generateNewToken(currentToken);
  //     const newToken = response.token;

  //     dispatch(actions.setItem(["token", newToken]));
  //   } catch (error) {
  //     console.error("Failed to refresh token:", error);
  //     dispatch(actions.logout());
  //     window.location.href = "/";
  //   }
  // };

  // useEffect(() => {
  //   const refreshInterval = setInterval(refreshToken, 15 * 60 * 1000);
  //   return () => clearInterval(refreshInterval);
  // }, []);

  // useEffect(() => {
  //   let inactivityTimeout;

  //   const resetInactivityTimer = () => {
  //     clearTimeout(inactivityTimeout);
  //     inactivityTimeout = setTimeout(
  //       () => {
  //         alert("You have been logged out due to inactivity.");
  //         dispatch(actions.logout());
  //         window.location.href = "/";
  //       },
  //       30 * 60 * 1000,
  //     );
  //   };

  //   window.addEventListener("mousemove", resetInactivityTimer);
  //   window.addEventListener("keydown", resetInactivityTimer);

  //   resetInactivityTimer();

  //   return () => {
  //     window.removeEventListener("mousemove", resetInactivityTimer);
  //     window.removeEventListener("keydown", resetInactivityTimer);
  //     clearTimeout(inactivityTimeout);
  //   };
  // }, []);

  const ProtectedRoute = ({ element }) => {
    const token = useSelector((store) => store.userReducer.token);
    const isTokenAvailable = !!token;

    return isTokenAvailable ? element : <Navigate to="/" />;
  };

  const ProtectedRouteForSuper = ({ element }) => {
    const role = useSelector((store) => store.userReducer.role);
    const isAllowed =
      role === "super" || role === "subSuper" || role === "admin" || role === "subAdmin"; 
    return isAllowed ? element : <Navigate to="*" />;
  };

  const ProtectedRouteForOps = ({ element }) => {
    const role = useSelector((store) => store.userReducer.role);
    const isTokenAvailable = role === "operation" || role === "accounts";

    return isTokenAvailable ? element : <Navigate to="*" />;
  };

  const ResellerRoute = () => {
    const role = useSelector((store) => store.userReducer.role);

    if (role === "reseller") {
      return <ResellerDashboard />;
    }

    return <AllResellerDashboard />;
  };

  const handleFile = (e) => {
    let fileTypes = [
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
    ];
    let selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile && fileTypes.includes(selectedFile.type)) {
        setTypeError(null);
        let reader = new FileReader();
        reader.readAsArrayBuffer(selectedFile);
        reader.onload = (e) => {
          setExcelFile(e.target.result);

          if (e.target.result) {
            const workbook = XLSX.read(e.target.result, { type: "buffer" });
            const worksheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[worksheetName];
            const data = XLSX.utils.sheet_to_json(worksheet);
            setExcelData(data.slice(0, 10));
            handleApiData(data.slice(0, 10));
          }
        };
      } else {
        setTypeError("Please select only excel file types");
        setExcelFile(null);
      }
    } else {
      console.log("Please select your file");
    }
  };

  return (
    <div className="main-cont">
      <Router>
        <Routes>
          <Route path="/" element={<LoginScreen />} />
          <Route path="/login" element={<LoginScreen />} />
          <Route path="/signup" element={<SignUpScreen />} />
          <Route element={<BaseLayout />}>
            <Route
              path="/dashboard"
              element={
                <ProtectedRouteForSuper element={<MerchantDashboard />} />
              }
            />
            <Route
              path="/merchant-overview"
              element={<ProtectedRoute element={<MerchantOverview />} />}
            />
            <Route
              path="/revenue"
              element={<ProtectedRoute element={<RevenuePage />} />}
            />
            <Route
              path="/usermanagement"
              element={<ProtectedRoute element={<UserManagement />} />}
            />
            <Route
              path="/pay-in"
              element={<ProtectedRoute element={<Payment />} />}
            />

            <Route
              path="/auto-payout-report"
              element={<ProtectedRoute element={<AutoPayoutReport />} />}
            />
            <Route
              path="/pay-out-report"
              element={<ProtectedRoute element={<PayOutReport />} />}
            />
            <Route
              path="/pay-out-form"
              element={
                <ProtectedRoute
                  element={<PayOutForm handleFile={handleFile} />}
                />
              }
            />
            <Route
              path="/direct-payout"
              element={<ProtectedRoute element={<DirectPayout />} />}
            />
            <Route
              path="/merchant-management"
              element={<ProtectedRoute element={<MerchantManagement />} />}
            />

            <Route
              path="/rolling-reserve"
              element={<ProtectedRoute element={<RollingReserve />} />}
            />
            <Route
              path="/rolling-reserve-settlements"
              element={
                <ProtectedRoute element={<RollingReserveSettlements />} />
              }
            />
            <Route
              path="/transaction-lookup"
              element={<ProtectedRoute element={<Lookup />} />}
            />
            <Route
              path="/create-chargeback"
              element={<ProtectedRoute element={<Reconciliation />} />}
            />
            <Route
              path="/chargeback-dashboard"
              element={<ProtectedRoute element={<ReconDashboard />} />}
            />
            <Route
              path="/view-chargeback"
              element={<ProtectedRoute element={<ReconciliationTable />} />}
            />

            <Route
              path="/complaints-dashboard"
              element={<ProtectedRoute element={<ComplaintsDashboard />} />}
            />

            <Route
              path="/create-complaints"
              element={<ProtectedRoute element={<Complaints />} />}
            />

            <Route
              path="/complaints"
              element={<ProtectedRoute element={<ApproveComplaints />} />}
            />

            <Route
              path="/todays-chargeback-data"
              element={<ProtectedRoute element={<TodaysChargeback />} />}
            />
            <Route
              path="/pre-chargeback-evaluation"
              element={<ProtectedRoute element={<PreChargebackEvaluation />} />}
            />
            {/* <Route
              path="/chargeback-stats"
              element={<ProtectedRoute element={<ChargebackStats />} />}
            /> */}
            <Route
              path="/todays-chargeback-data"
              element={<ProtectedRoute element={<TodaysChargeback />} />}
            />
            <Route
              path="/pre-chargeback-evaluation"
              element={<ProtectedRoute element={<PreChargebackEvaluation />} />}
            />
            <Route
              path="/change-password"
              element={<ProtectedRoute element={<ChangePassword />} />}
            />
            <Route
              path="/settlement"
              element={<ProtectedRoute element={<SettlementPage />} />}
            />
            <Route
              path="/download-report"
              element={<ProtectedRoute element={<DownloadGenerateReports />} />}
            />
            <Route
              path="/apipage"
              element={<ProtectedRoute element={<ApiIntegrationPage />} />}
            />
            <Route
              path="/refund"
              element={<ProtectedRoute element={<RefundPage />} />}
            />
            <Route
              path="/setting"
              element={<ProtectedRoute element={<SettingPage />} />}
            />
            <Route
              path="/add-provider"
              element={<ProtectedRoute element={<AddProvider />} />}
            />
            <Route
              path="/get-provider"
              element={<ProtectedRoute element={<GetProvider />} />}
            />
            <Route
              path="/check-provider"
              element={<ProtectedRoute element={<CheckProvider />} />}
            />
            <Route
              path="/provider-tracking"
              element={<ProtectedRoute element={<ProviderTrackingScreen />} />}
            />
            <Route
              path="/monthly-analytics"
              element={<ProtectedRoute element={<MonthlyAnalytics />} />}
            />

            <Route
              path="/account"
              element={<ProtectedRoute element={<AccountNavbar />} />}
            >
              <Route index element={<Navigate to="details" replace />} />
              <Route
                path="details"
                element={<ProtectedRoute element={<AccountPage />} />}
              />
              <Route
                path="merchant-webhooks"
                element={<ProtectedRoute element={<MerchantWebhooks />} />}
              />
              <Route
                path="api-key"
                element={<ProtectedRoute element={<MerchantApiKey />} />}
              />
              <Route
                path="ips-merchant"
                element={<ProtectedRoute element={<MerchantIPs />} />}
              />
            </Route>


            <Route
              path="/activity"
              element={<ProtectedRoute element={<ActivityPage />} />}
            >
              <Route index element={<Navigate to="change-status" replace />} />
              <Route
                path="change-status"
                element={<ProtectedRoute element={<ActivityStatusPage />} />}
              />
              <Route
                path="blocked-user"
                element={<ProtectedRoute element={<BlockedUserPage />} />}
              />
              <Route
                path="raw-webhook"
                element={<ProtectedRoute element={<RawWebhookPage />} />}
              />
              <Route
                path="notFound-webhook"
                element={<ProtectedRoute element={<NotFoundWebhookPage />} />}
              />
              <Route
                path="change-password"
                element={<ProtectedRoute element={<ChangePasswordPage />} />}
              />
              <Route
                path="block-keyword"
                element={<ProtectedRoute element={<BlockKeywordPage />} />}
              />
            </Route>
            <Route
              path="/overview"
              element={<ProtectedRoute element={<DashboardAnalyst />} />}
            />
            <Route
              path="/orgTable"
              element={<ProtectedRoute element={<OrgTable />} />}
            />
            <Route
              path="/add-organization"
              element={<ProtectedRoute element={<AddOrg />} />}
            />
            <Route
              path="/add-settlement"
              element={<ProtectedRoute element={<AddSettlements />} />}
            />
            <Route
              path="/view-settlement"
              element={<ProtectedRoute element={<GetSettlements />} />}
            />
            <Route
              path="/wallet-upload"
              element={<ProtectedRoute element={<WalletUpload />} />}
            />
            {/* <Route
              path="/wallet-balance"
              element={<ProtectedRoute element={<WalletBalance/>} />}
            /> */}
            <Route
              path="/wallet-transactions"
              element={<ProtectedRoute element={<WalletTransactionTable />} />}
            />
            {/* <Route
              path="/passbook"
              element={<ProtectedRoute element={<Passbook />} />}
            /> */}
            <Route
              path="/control-panel"
              element={<ProtectedRoute element={<ControlPanel />} />}
            />
            {/* <Route
              path="/merchant-webhooks"
              element={<ProtectedRoute element={<MerchantWebhooks />} />}
            />
            <Route
              path="/ips-merchant"
              element={<ProtectedRoute element={<MerchantIPs />} />}
            />
            <Route
              path="/api-key"
              element={<ProtectedRoute element={<MerchantApiKey />} />}
            /> */}
            <Route
              path="change-status"
              element={<ProtectedRoute element={<ChangeStatus />} />}
            />
            <Route
              path="payin-upload"
              element={<ProtectedRouteForOps element={<PayinUpload />} />}
            />
            <Route
              path="/register-provider"
              element={<ProtectedRoute element={<RegisterAutoSwitch />} />}
            />
            <Route
              path="/view-auto-switch"
              element={<ProtectedRoute element={<ViewAutoSwitch />} />}
            />

            <Route
              path="/vpa-pool"
              element={<ProtectedRoute element={<VpaPool />} />}
            />
            <Route
              path="/vpa-usage"
              element={<ProtectedRoute element={<VpaUsage />} />}
            />

            <Route
              path="wallet-request"
              element={<ProtectedRoute element={<WalletRequest />} />}
            />
            <Route
              path="wallet-history"
              element={<ProtectedRoute element={<WalletHistory />} />}
            />
            <Route
              path="wallet-pending"
              element={<ProtectedRoute element={<WalletPending />} />}
            />
            <Route
              path="/settlement-report"
              element={<ProtectedRoute element={<SettlementReport />} />}
            />
            <Route
              path="/provider-settlement"
              element={<ProtectedRoute element={<TotalProviderSettlement />} />}
            />
            <Route
              path="/merchant-settlement"
              element={<ProtectedRoute element={<MerchantSettlement />} />}
            />
            <Route
              path="/settlement-report"
              element={<ProtectedRoute element={<SettlementReport />} />}
            />
            <Route
              path="/provider-settlement"
              element={<ProtectedRoute element={<TotalProviderSettlement />} />}
            />
            {/* <Route
              path="/merchant-settlement"
              element={<ProtectedRoute element={<MerchantSettlement />} />}
            /> */}
            <Route
              path="/approve-settlement"
              element={<ProtectedRoute element={<ApproveSettlement />} />}
            />
            <Route
              path="/approve-rr-settlement"
              element={
                <ProtectedRoute element={<ApproveRollingSettlement />} />
              }
            />
            <Route
              path="/generate-products"
              element={<ProtectedRouteForOps element={<GenerateProducts />} />}
            />
            <Route
              path="/not-found-webhook"
              element={<ProtectedRoute element={<NotFoundWebhookPage />} />}
            />
                <Route
              path="/notifications"
              element={<ProtectedRoute element={<NotificationsPage />} />}
            >
              <Route index element={<Navigate to="duplicate-webhook" replace />} />
              <Route
                path="duplicate-webhook"
                element={<ProtectedRoute element={<ShowNotifcation />} />}
              />
              <Route
                path="chargeback-tnx"
                element={<ProtectedRoute element={<FraudChargeback />} />}
              />
              <Route
                path="error-webhoook"
                element={<ProtectedRoute element={<ErrorWebhook />} />}
              />
              <Route
                path="suspicious-tnx"
                element={<ProtectedRoute element={<SuspiciousTnx />} />}
              />
              <Route
                path="whitelist-requests"
                element={<ProtectedRoute element={<WhitelistRequest />} />}
              />
            </Route>
            <Route
              path="/vpa-refund"
              element={<ProtectedRoute element={<VpaRefund />} />}
            />
            <Route
              path="/user-provider-set"
              element={<ProtectedRoute element={<ProviderUserSet />} />}
            />
            <Route
              path="/provider-wallet"
              element={<ProtectedRoute element={<ProviderWallet />} />}
            />
            <Route
              path="/provider-balance"
              element={
                <ProtectedRoute element={<ProviderWalletAvilableBalance />} />
              }
            />
            <Route
              path="/payout-pendding"
              element={<ProtectedRoute element={<ClearPending />} />}
            />
            <Route
              path="/payout-uuid"
              element={<ProtectedRoute element={<UuidPayout />} />}
            />

            <Route
              path="/return-report"
              element={<ProtectedRoute element={<ReconMatch />} />}
            />

            <Route
              path="/transaction-summary"
              element={<ProtectedRoute element={<TransactionSummary />} />}
           />

              <Route
              path="/payment-exceptions"
              element={<ProtectedRoute element={<PaymentExceptionDashboard />} />}
            />
             <Route
              path="/pending-payouts"
              element={<ProtectedRoute element={<PendingPayouts />} />}
            />

              <Route
              path="/muffin-amount"
              element={<ProtectedRoute element={<MuffinAmount />} />}
            />
            <Route
              path="/payout-pending-summary"
              element={<ProtectedRoute element={<PayoutPendingSummary />} />}
            />
            <Route
              path="/payout-Pending-data"
              element={<ProtectedRoute element={<PayoutPendingGetData />} />}
            />
             <Route
              path="/failed-pending-payout"
              element={<ProtectedRoute element={<PayoutPendingFailed />} />}
            />
            <Route
              path="/retry-callback"
              element={<ProtectedRoute element={<RetryCallback />} />}
            />
            <Route
              path="/muffin-clear"
              element={<ProtectedRoute element={<MuffinClear />} />}
            />
            <Route
              path="/ns-pay-report"
              element={<ProtectedRoute element={<NSpayReport />} />}
            />

             <Route
              path="/ninja-clear"
              element={<ProtectedRoute element={<PayNinjaClear />} />}
            />
            <Route
              path="/webhook-tracker"
              element={<ProtectedRoute element={<WebhookTracker />} />}
            />
            <Route
              path="/get-reseller-data"
              element={<ProtectedRoute element={<ResellerRoute />} />}
            />
            <Route
              path="/get-reseller"
              element={<ProtectedRoute element={<GetReseller />} />}
            />
            <Route path="/get-reseller-management"
              element={<ProtectedRoute element={<ResellerManagement />} />}
            />
            <Route
              path="/reseller-wallet"
              element={<ProtectedRoute element={<ResellerWallet />} />}
            />
            <Route
              path="/get-reseller-wallet"
              element={<ProtectedRoute element={<GetAllResellerWallet />} />}
            />
             <Route
              path="/user-ledger"
              element={<ProtectedRoute element={<UserAnalytics />} />}
            />
             <Route
              path="/block-fraud-users"
              element={<ProtectedRoute element={<BlockFraudUsers />} />}
            />
            <Route
              path="*"
              element={<ProtectedRoute element={<PageNotFound />} />}
            />
          </Route>
        </Routes>
      </Router>
    </div>
  );
}

export default App;
